/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Location_HeaderInputs */



/**
* | output |
* | --- |
* | "Location" |
*
* @param {Explorer_Search_Location_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_location_header = /** @type {((inputs?: Explorer_Search_Location_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Location_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Location")
	if (locale === "de") return /** @type {LocalizedString} */ ("Location")
	if (locale === "it") return /** @type {LocalizedString} */ ("Location")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Location")
	if (locale === "es") return /** @type {LocalizedString} */ ("Location")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Location")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Location")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Location")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Location")
	return /** @type {LocalizedString} */ ("Location")
});